<script lang="ts">import { t, Verbiage } from "@infinitro/content";
import { getIcon } from "../data/icons";
const NewGamesTabIcon = getIcon("NewGamesTabIcon");
export let size = 17;
export let active = false;
export let hover = false;
export let color = undefined;
</script>

{#if typeof NewGamesTabIcon === 'string'}
	<img src={NewGamesTabIcon} alt={$t(Verbiage.icon_alt, 'alts')} />
{:else if typeof NewGamesTabIcon === 'function'}
	<svelte:component this={NewGamesTabIcon} {size} {active} {hover} {color} />
{:else}
	<span>Invalid icon</span>
{/if}

<style>
</style>
